"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.user.exceeded': 'Límite de usuarios alcanzado. Actualice su plan para agregar más usuarios.',
    'limits.user.limitReached': 'Límite de usuarios: {limit} (actualizar para más)',
};
